module.exports = __webpack_public_path__ + "media/promo/lum2021/images/footerm-b0c165d16b2475749e39b2efb94e7192.jpg";